import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    // W3Schools Email API endpoint
    const url = 'https://formsubmit.co/developer@valarccifoundation.co.in';

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setStatus({
        submitting: false,
        submitted: true,
        error: null
      });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    })
    .catch(error => {
      console.error('Error:', error);
      setStatus({
        submitting: false,
        submitted: false,
        error: 'Failed to send message. Please try again.'
      });
    });
  };

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#6dd5ed] to-[#eecda3]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">Contact Us</h1>
          <p className="text-xl text-black">Get in touch with us for any queries or support</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="bg-gradient-to-br to-[#eecda3] backdrop-blur-sm rounded-lg p-8 shadow-xl border border-gray-700">
            <h2 className="text-2xl font-bold text-blue-400 mb-6">Contact Information</h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <FaPhone className="text-blue-400 text-xl mt-1" />
                <div className="text-left">
                  <h3 className="text-black font-semibold">Phone</h3>
                  <p className="text-black">+91 8053232672</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaEnvelope className="text-blue-400 text-xl mt-1" />
                <div className="text-left">
                  <h3 className="text-black font-semibold">Email</h3>
                  <a 
                    href="mailto:director@valarccifoundation.co.in" 
                    className="text-black hover:text-blue-500 transition-colors"
                  >
                    director@valarccifoundation.co.in
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaMapMarkerAlt className="text-blue-400 text-xl mt-1" />
                <div className="text-left">
                  <h3 className="text-black font-semibold">Address</h3>
                  <p className="text-black">Vpo. Bandaheri, Hisar, Haryana 125001</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaGlobe className="text-blue-400 text-xl mt-1" />
                <div className="text-left">
                  <h3 className="text-black font-semibold">Website</h3>
                  <p className="text-black">valarccifoundation.co.in</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gradient-to-br to-[#6dd5ed] backdrop-blur-sm rounded-lg p-8 shadow-xl border border-gray-700">
            <h2 className="text-2xl font-bold text-blue-400 mb-6">Send us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-black mb-2">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded bg-transparent text-black border border-gray-600 focus:border-blue-400 focus:outline-none backdrop-blur-sm"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-black mb-2">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded bg-transparent text-black border border-gray-600 focus:border-blue-400 focus:outline-none backdrop-blur-sm"
                  required
                />
              </div>
              <div>
                <label htmlFor="subject" className="block text-black mb-2">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded bg-transparent text-black border border-gray-600 focus:border-blue-400 focus:outline-none backdrop-blur-sm"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-black mb-2">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full px-4 py-2 rounded bg-transparent text-black border border-gray-600 focus:border-blue-400 focus:outline-none backdrop-blur-sm"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={status.submitting}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-black py-3 px-6 rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-[1.02]"
              >
                {status.submitting ? 'Sending...' : 'Send Message'}
              </button>
              
              {status.submitted && (
                <p className="text-green-600 text-center mt-4">
                  Thank you for your message! We'll get back to you soon.
                </p>
              )}
              
              {status.error && (
                <p className="text-red-600 text-center mt-4">
                  {status.error}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 